export default function shouldDoGeographicPagination(): boolean {
  return (
    !VisitWidget.settings.refreshMapMarkersDisabled &&
    (VisitWidget.settings.geographicPaginationEnabled ||
      VisitWidget.store.currentMenuItem.entity === "PlanItem")
  );
}
